import { convertToDefaultDateFormat, convertToDefaultBackendFormat } from "@/util"
import reservedItemModel from "./models/reservedItemModel"
import Vue from "vue"

export const RESERVED_ARG = {
  LOCATION : 'location',
  DATETIME: 'datetime',
  QUANTITY: 'quantity',
  CBR_USER: 'cbr_user',
  PRODUCT_NAME: 'product_name'
}

export default class ReservedModel {
  constructor() {
    this.list = {}
    this.$set = null
  }

  setList(payload, set) {
    this.$set = set
    payload.forEach(slot => {
      let date = convertToDefaultBackendFormat(slot[RESERVED_ARG.DATETIME])
      slot.date = date
      if(date in this.list) {
        this.setToLocation(slot, date)
      }
      else {
        this.setToDate(slot, date)
      }
    })
  }

  setToLocation(slot, date) {
    if(slot[RESERVED_ARG.LOCATION] in this.list[date])
      this.list[date][slot[RESERVED_ARG.LOCATION]].push(new reservedItemModel(slot))
    else  Vue.set(this.list[date], [slot[RESERVED_ARG.LOCATION]], [new reservedItemModel(slot)])
   
  }

  setToDate(slot, date) {
    let item = {
      [slot[RESERVED_ARG.LOCATION]]: [new reservedItemModel(slot)]
    }
    Vue.set(this.list, date, item)
  }
}